const getLayoutSettingsByPage = (state) => (pageName) => state.layoutSettings.find((item) => item.page === pageName);
const getCustomFieldByEntity = (state) => (entity) => state.custom_fields[entity];
const configuredAiKeyProviders = (state) => state.aiKeys.map((credential) => credential.provider);

export default {
  getLayoutSettingsByPage,
  getCustomFieldByEntity,
  configuredAiKeyProviders,
}
